define('_models/default',[
	
],
function(
	
) {

	return Backbone.Model.extend({

		initialize: function(){

		},

		fetch : function(options) {
			if ( $("script[data-set='Default']").html() ) {
				this.set( $.parseJSON( $("script[data-set='Default']").html() ), options );
				$("script[data-set='Default']").remove();

			} else {
				Backbone.Model.prototype.fetch.apply(this, arguments);    
			}
		},

	});

});

